class Scopes {
  scopesAvailable = [];

  /**
   * @method set
   * @param {object} scopes
   */
  set = (scopes) => this.scopesAvailable = scopes.map(scope => scope.scope);

  /**
   * @method has
   * @param {array|string} scopes
   * @return {boolean}
   */
  has = (scopes) => {
    // return false;
    scopes = typeof scopes === 'string' ? [scopes] : scopes;

    const scopesMatched = this.scopesAvailable.filter((scope) => {
      if (scopes.indexOf(scope) !== -1) {
        return true;
      } else {
        let matched = false;

        scopes.map(s => {
          if (s.indexOf('.*') !== -1) {
            const prefix = s.split('.')[0];
            const prefixScope = scope.split('.')[0];

            if (prefix === prefixScope) {
              matched = true;
            }
          }
        });

        return matched;
      }
    });

    return scopesMatched.length !== 0;
  }
}

export default new Scopes();
